import React from "react";
import displayConditions from "../../utils";
import Element from "../Element";
import shopOrOnlineElements from "./elements";
import styles from "./styles.module.scss";

const ShopOrOnline = ({ responses, handleChange }) => {
  const shouldDisplay = displayConditions(responses);
  return (
    <div className={styles.elementContainer}>
      {shopOrOnlineElements.map(element => {
        if (shouldDisplay(element.id)) {
          return <Element key={element.id} element={element} responses={responses} handleChange={handleChange} />;
        }
        return null;
      })}
    </div>
  );
};

export default ShopOrOnline;
